import React from "react"
import { Link } from "gatsby"
export default function Pager({ pageContext }) {
  const { previousPagePath, nextPagePath } = pageContext

  return (
    <div className="d-flex justify-content-between p-4 pt-0">
      <Link
        to={previousPagePath}
        className="btn btn-outline-primary float-left"
      >
        ← Previous Page
      </Link>

      <Link to={nextPagePath} className="btn btn-outline-primary text-right">
        Next Page →
      </Link>
    </div>
  )
}
